import { Chart } from 'chart.js/auto'
import ChartDataLabels from 'chartjs-plugin-datalabels'

class BarChart extends HTMLElement {
  #shadow: ShadowRoot
  #canvas?: HTMLCanvasElement
  datasets: any
  orientation: string
  width: number
  height: number
  options: any

  constructor() {
    super()
    this.#shadow = this.attachShadow({ mode: 'open' })
    this.orientation = 'horizontal'
    this.width = 400
    this.height = 300
  }

  connectedCallback() {
    this.#render()
  }

  #render() {
    const datasets = this.datasets.toArray()
    const orientation = this.orientation
    const isHorizontal = orientation === 'horizontal'

    const emptyState =
      datasets.length > 0
        ? datasets
        : [
            {
              colors: { toArray: () => ['#D3D3D3'] },
              data: { toArray: () => [0] },
              labels: { toArray: () => ['Default'] },
              title: '',
            },
          ]

    const options = this.options
    const wrapper = document.createElement('div')
    wrapper.style.position = 'relative'
    wrapper.style.width = '100%'
    wrapper.style.height = '100%'
    this.#canvas = document.createElement('canvas')
    this.#canvas.width = this.width
    this.#canvas.height = this.height
    wrapper.appendChild(this.#canvas)
    this.#shadow.appendChild(wrapper)

    const basic_dataset_config = {
      fill: 'origin',
      tension: 0.4,
    }

    new Chart(this.#canvas, {
      type: options.chart_type ?? 'bar',
      data: {
        labels: emptyState[0].labels.toArray(),
        datasets: emptyState.map((dataset: any) => ({
          ...basic_dataset_config,
          backgroundColor: dataset.colors.toArray(),
          data: dataset.data.toArray(),
          labels: dataset.labels.toArray(),
          label: dataset.title,
        })),
      },
      options: {
        layout: {
          padding: 10,
        },
        indexAxis: isHorizontal ? 'y' : 'x',
        responsive: true,
        events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter: (value: number) => value.toFixed(0), // Format numbers as integers
            color: '#000', // Text color
          },
          legend: {
            display: true,
            onClick: (e: any, legendItem: any, legend: any) => {
              const index = legendItem.datasetIndex
              const ci = legend.chart
              const meta = ci.getDatasetMeta(index)
              // Cacher/montrer la courbe au clic sur légende
              meta.hidden =
                meta.hidden === null ? !ci.data.datasets[index].hidden : null
              ci.update()
            },
          },
        },
        interaction: {
          mode: 'nearest',
          axis: 'x',
          intersect: false,
        },
        scales: {
          x: {
            stacked: options.stacked == true,
            grid: {
              display: false, // Disable grid lines on the x-axis
            },
          },
          y: {
            beginAtZero: true,
            stacked: this.options.stacked == true,
            grid: {
              display: false, // Disable grid lines on the y-axis
            },
            ticks: {
              display: true, // Remove the labels on the y-axis
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    })
  }

  // Lifecycle functions.
  disconnectedCallback() {}
  adoptedCallback() {}
  attributeChangedCallback() {}
}

export function register() {
  customElements.define('bar-chart', BarChart)
}
